import { render, staticRenderFns } from "./QuickAddButton.vue?vue&type=template&id=62b02051&scoped=true"
import script from "./QuickAddButton.vue?vue&type=script&lang=ts"
export * from "./QuickAddButton.vue?vue&type=script&lang=ts"
import style0 from "./QuickAddButton.vue?vue&type=style&index=0&id=62b02051&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b02051",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62b02051')) {
      api.createRecord('62b02051', component.options)
    } else {
      api.reload('62b02051', component.options)
    }
    module.hot.accept("./QuickAddButton.vue?vue&type=template&id=62b02051&scoped=true", function () {
      api.rerender('62b02051', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboard/QuickAddButton.vue"
export default component.exports